module.exports = __webpack_public_path__ + "img/coupon_recieve.6ba20f97.png";